/** components/Input.tsx */
import { AtomInput, AtomInputProps } from '@/atoms/input'
import { css } from '@emotion/react'
import { Interpolation, Theme } from '@emotion/react/dist/declarations/src'
import { forwardRef } from 'react'

const style = (t: Theme) => css`
  display: block;
  height: 36px;
  padding: ${t.s.xxs}px;
  border-style: solid;
  border-width: 1px;
  font: unset;
  font-size: ${t.fs.sm};
  color: ${t.c.bc.text};
  line-height: ${t.fs.sm};
  border-radius: ${t.rd.default};
  border-color: ${t.c.ec.mediumGray};
  transition: all 0.1s;
  box-sizing: border-box;
  &:focus {
    outline: 2px solid ${t.c.bc.primary};
  }
  &:disabled {
    background-color: ${t.c.bc.disabled};
    cursor: not-allowed;
  }
`

const ERROR_COLOR = '#FF0000'

const errorStyle = () => css`
  border-color: ${ERROR_COLOR};

  &:focus {
    outline: 2px solid ${ERROR_COLOR};
  }
`
const widthStyle = () => css`
  width: 100%;
`

type InputProps = AtomInputProps

export type Props = {
  isError?: boolean
  isFullWidth?: boolean
  addStyle?: Interpolation<Theme>
} & InputProps

export const BaseInput = forwardRef<HTMLInputElement, Props>(
  (
    { isError = false, isFullWidth = false, addStyle, ...attr }: Props,
    forwardedRef,
  ) => {
    return (
      <AtomInput
        {...attr}
        ref={forwardedRef}
        css={[
          style,
          addStyle,
          isError && errorStyle,
          isFullWidth && widthStyle,
        ]}
      />
    )
  },
)
